import { Button } from "@kds-web/button";
import { MessageOutlineIcon } from "@kds-web/icons";
import { useEffect, useState } from "react";
import type { JSX } from "react/jsx-runtime";
import { UAParser } from "ua-parser-js";
import { trackGAEvent } from "../../../../utils/google-analytics/tracking.ts";

interface FeedbackSurveyProps {
  originForTracking: string;
}

function FeedbackSurvey({
  originForTracking,
}: FeedbackSurveyProps): JSX.Element {
  const [surveyUrl, setSurveyUrl] = useState("");

  useEffect(() => {
    if (!document.cookie.includes("homepageSurveyClicked=1")) {
      const parser = new UAParser();
      const browser = parser.getResult().browser;

      setSurveyUrl(
        `https://de.surveymonkey.com/r/XXYTL85?AppVersion=${
          browser.version
        }&BrowserType=${browser.name}&DeviceType=desktop`,
      );
    }
  }, []);

  function handleClickOnSurvey(): void {
    document.cookie =
      "homepageSurveyClicked=1;max-age=7776000;path=/"; /** Set cookie with expiration time of 90 days = 7776000 */
    trackGAEvent({
      eventCategory: originForTracking,
      eventAction: "ClickOnSurvey",
    });
    window.open(surveyUrl, "_blank");
  }

  return (
    <div
      /* Card width is fixed to 165px on 1rem and will change to 400px when the font sizes reaches 22px */
      className="relative flex h-[220px] w-[clamp(165px,165px+(1rem-22px)*100000,400px)]
     flex-col bg-primaryContainer shadow-soft hover:shadow-elevation"
    >
      <div className="flex gap-xxsmall p-xsmall">
        <MessageOutlineIcon size="medium" className="text-interactive" />
        <span className="text-bodySmall font-regular text-onPrimaryContainer">
          Feedback geben
        </span>
      </div>
      <div className="mx-xsmall my-large flex ">
        <p className="flex flex-wrap overflow-hidden text-bodyLargeStrong text-onPrimaryContainer">
          Hilf uns, deine Startseite zu verbessern.
        </p>
      </div>
      <div className="flex justify-center px-small">
        <Button
          label="Zur Umfrage"
          variant="secondary"
          size="small"
          className="w-full border-onConfirmContainer text-onPrimaryContainer"
          onClick={handleClickOnSurvey}
        />
      </div>
    </div>
  );
}

export default FeedbackSurvey;
